export enum handicapsTypes {
  FETCH_HANDICAPS_REQUEST = "FETCH_HANDICAPS_REQUEST",
  FETCH_HANDICAPS_SUCCESS = "FETCH_HANDICAPS_SUCCESS",
  FETCH_HANDICAPS_FAILURE = "FETCH_HANDICAPS_FAILURE",
}